import { ChecklistItem } from './Common.model';
import { EngageChecklistCategory } from './Engage.model';

/* Dictionary of Categories/ChecklistItems used on the Engage action center*/
export type CheckListDictionary = {
    [key: string]: CheckListItemDisplay[];
};

export interface CheckListItemDisplay extends ChecklistItem {
    headerKey: string;
    contentKey: string;
    isContentOnly?: boolean;
    hasActions?: boolean;
    isDefaultExpanded?: boolean;
}

/* List of checklistItems used on Engage ActionCenter*/
export const checkListItems: CheckListDictionary = {
    [EngageChecklistCategory.unknown]: [],
    [EngageChecklistCategory.preSurvey]: [
        {
            name: 'uploadOrgData',
            isComplete: false,
            headerKey: 'engage-preSurvey.uploadOrgData-header',
            contentKey: 'engage-preSurvey.uploadOrgData-body',
            hasActions: true,
            isDefaultExpanded: true
        },
        {
            name: 'previewSurveyExample',
            isComplete: false,
            headerKey: 'engage-preSurvey.previewSurveyExample-header',
            contentKey: 'engage-preSurvey.previewSurveyExample-body',
            hasActions: true
        },
        {
            name: 'scheduleSurvey',
            isComplete: false,
            headerKey: 'engage-preSurvey.scheduleSurvey-header',
            contentKey: 'engage-preSurvey.scheduleSurvey-body',
            hasActions: true
        },
        {
            name: 'preSurveyInfo',
            isComplete: false,
            headerKey: '',
            contentKey: 'engage-preSurvey.weeksPrior-body',
            isContentOnly: true
        },
        {
            name: 'sendReadinessEmails',
            isComplete: false,
            headerKey: 'engage-preSurvey.sendReadinessEmails-header',
            contentKey: 'engage-preSurvey.sendReadinessEmails-body',
            hasActions: true
        }
    ],
    [EngageChecklistCategory.duringSurvey]: [
        {
            name: 'scheduleRehearsal',
            isComplete: false,
            headerKey: 'engage-duringSurvey.scheduleRehearsal-header',
            contentKey: 'engage-duringSurvey.scheduleRehearsal-body',
            isDefaultExpanded: true
        },
        {
            name: 'duringSurveyInfo_ongoing',
            isComplete: false,
            headerKey: '',
            contentKey: 'engage-duringSurvey.ongoing-body',
            isContentOnly: true
        },
        {
            name: 'monitorParticipation',
            isComplete: false,
            headerKey: 'engage-duringSurvey.monitorParticipation-header',
            contentKey: 'engage-duringSurvey.monitorParticipation-body',
            hasActions: true
        },
        {
            name: 'duringSurveyInfo_after',
            isComplete: false,
            headerKey: '',
            contentKey: 'engage-duringSurvey.weeksAfter-body',
            isContentOnly: true
        },
        {
            name: 'closeSurvey',
            isComplete: false,
            headerKey: 'engage-duringSurvey.closeSurvey-header',
            contentKey: 'engage-duringSurvey.closeSurvey-body',
            hasActions: true
        }
    ],
    [EngageChecklistCategory.postSurvey]: [
        {
            name: 'postSurveyInfo_week1',
            isComplete: false,
            headerKey: '',
            contentKey: 'engage-postSurvey.week1AfterClose-body',
            isContentOnly: true
        },
        {
            name: 'reviewInsights',
            isComplete: false,
            headerKey: 'engage-postSurvey.reviewInsights-header',
            contentKey: 'engage-postSurvey.reviewInsights.body',
            hasActions: true,
            isDefaultExpanded: true
        },
        {
            name: 'prepareExecDeck',
            isComplete: false,
            headerKey: 'engage-postSurvey.prepareExecDeck-header',
            contentKey: 'engage-postSurvey.prepareExecDeck-body',
            hasActions: true
        },
        {
            name: 'scheduleSession',
            isComplete: false,
            headerKey: 'engage-postSurvey.scheduleSession-header',
            contentKey: 'engage-postSurvey.scheduleSession-body'
        },
        {
            name: 'shareResultsExec',
            isComplete: false,
            headerKey: 'engage-postSurvey.shareResultsExec-header',
            contentKey: 'engage-postSurvey.shareResultsExec-body'
        },
        {
            name: 'postSurveyInfo_week2',
            isComplete: false,
            headerKey: '',
            contentKey: 'engage-postSurvey.week2AfterClose-body',
            isContentOnly: true
        },
        {
            name: 'debriefManagers',
            isComplete: false,
            headerKey: 'engage-postSurvey.debriefManagers-header',
            contentKey: 'engage-postSurvey.debriefManagers-body'
        },
        {
            name: 'scheduleWorkshops',
            isComplete: false,
            headerKey: 'engage-postSurvey.scheduleWorkshops-header',
            contentKey: 'engage-postSurvey.scheduleWorkshops-body'
        },
        {
            name: 'postSurveyInfo_week3',
            isComplete: false,
            headerKey: '',
            contentKey: 'engage-postSurvey.week3AfterClose-body',
            isContentOnly: true
        },
        {
            name: 'organizationCommunication',
            isComplete: false,
            headerKey: 'engage-postSurvey.organizationCommunication-header',
            contentKey: 'engage-postSurvey.organizationCommunication-body'
        },
        {
            name: 'takeAction',
            isComplete: false,
            headerKey: 'engage-postSurvey.takeAction-header',
            contentKey: 'engage-postSurvey.takeAction-body'
        },
        {
            name: 'postSurveyInfo_month',
            isComplete: false,
            headerKey: '',
            contentKey: 'engage-postSurvey.monthsAfterClose-body',
            isContentOnly: true
        },
        {
            name: 'reflectAdjust',
            isComplete: false,
            headerKey: 'engage-postSurvey.reflectAdjust-header',
            contentKey: 'engage-postSurvey.reflectAdjust-body'
        }
    ]
};
